<template>
    <PopupRouterViewDetail label="Receipt From Production Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Receipt From Production" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="workOrderProcessDetails" optionsLabel="part" optionsKey="id" label-cols-lg="12" label="Work Order" id="fieldset-work-order-process-detail" size="sm" :model.sync="model.workOrderProcessDetailId"   :selected="model.workOrderProcessDetail != null ? model.workOrderProcessDetail.lotNo : ''" @input="getWorkOrderProcessDetails" @change="updateData"  :isUpdatable="false" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderProcessDetail" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData"  :isUpdatable="false" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Receipt From Production Material" :bordered="true" :items="receiptFromProductionMaterials" :fields="fieldsReceiptFromProductionMaterial" :busy="isDataLoading" :sort-by.sync="sortByReceiptFromProductionMaterial" :sort-desc.sync="sortDescReceiptFromProductionMaterial" small responsive
			@editButtonMethod="editRowDataReceiptFromProductionMaterial"
			@deleteButtonMethod="deleteRowDataReceiptFromProductionMaterial"
			@showPopupAddMethod="resetDataReceiptFromProductionMaterial()"
			@showPopupUploadMethod="showPopupUploadReceiptFromProductionMaterial()"
			@downloadMethod="downloadReceiptFromProductionMaterial()"
			@addFromClipboardMethod="addFromClipboardReceiptFromProductionMaterial()"
			@replaceFromClipboardMethod="replaceFromClipboardReceiptFromProductionMaterial()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadReceiptFromProductionMaterial"
			>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( receiptFromProductionMaterialPageSize * (currentReceiptFromProductionMaterialPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-receipt-from-production-material-control-card-' + row.index" label-cols-lg="12" label="Source Material" size="sm" :model.sync="row.item.controlCardId" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"  @change="saveInputReceiptFromProductionMaterial(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-receipt-from-production-material-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputReceiptFromProductionMaterial(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyBefore)="row">
				<app-input-textbox :id="'input-receipt-from-production-material-qty-before-' + row.index" label-cols-lg="12" label="Qty Before" size="sm" :model.sync="row.item.qtyBefore"   @change="saveInputReceiptFromProductionMaterial(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyAfter)="row">
				<app-input-textbox :id="'input-receipt-from-production-material-qty-after-' + row.index" label-cols-lg="12" label="Qty After" size="sm" :model.sync="row.item.qtyAfter"   @change="saveInputReceiptFromProductionMaterial(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyTaken)="row">
				<app-input-textbox :id="'input-receipt-from-production-material-qty-taken-' + row.index" label-cols-lg="12" label="Qty Taken" size="sm" :model.sync="row.item.qtyTaken"   @change="saveInputReceiptFromProductionMaterial(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>

		</app-table-input-popup>
		<app-table-input-popup title="Receipt From Production Case" :bordered="true" :items="receiptFromProductionCases" :fields="fieldsReceiptFromProductionCase" :busy="isDataLoading" :sort-by.sync="sortByReceiptFromProductionCase" :sort-desc.sync="sortDescReceiptFromProductionCase" small responsive
			@editButtonMethod="editRowDataReceiptFromProductionCase"
			@deleteButtonMethod="deleteRowDataReceiptFromProductionCase"
			@showPopupAddMethod="resetDataReceiptFromProductionCase()"
			@showPopupUploadMethod="showPopupUploadReceiptFromProductionCase()"
			@downloadMethod="downloadReceiptFromProductionCase()"
			@addFromClipboardMethod="addFromClipboardReceiptFromProductionCase()"
			@replaceFromClipboardMethod="replaceFromClipboardReceiptFromProductionCase()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadReceiptFromProductionCase"
			>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( receiptFromProductionCasePageSize * (currentReceiptFromProductionCasePage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-receipt-from-production-case-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"  @change="saveInputReceiptFromProductionCase(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-receipt-from-production-case-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputReceiptFromProductionCase(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyMaterial)="row">
				<app-input-textbox :id="'input-receipt-from-production-case-qty-material-' + row.index" label-cols-lg="12" label="Qty Material" size="sm" :model.sync="row.item.qtyMaterial"   @change="saveInputReceiptFromProductionCase(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyCase)="row">
				<app-input-textbox :id="'input-receipt-from-production-case-qty-case-' + row.index" label-cols-lg="12" label="Qty Case" size="sm" :model.sync="row.item.qtyCase"   @change="saveInputReceiptFromProductionCase(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ReceiptFromProduction from '@/models/ReceiptFromProduction/ReceiptFromProduction';
import ReceiptFromProductionList from '@/models/ReceiptFromProduction/ReceiptFromProductionList';
import ReceiptFromProductionFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import ReceiptFromProductionMaterial from '@/models/ReceiptFromProduction/ReceiptFromProductionMaterial';
import ReceiptFromProductionMaterialFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionMaterialFilter';
import ReceiptFromProductionCase from '@/models/ReceiptFromProduction/ReceiptFromProductionCase';
import ReceiptFromProductionCaseFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionCaseFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import ReceiptFromProductionMaterialInput from '@/views/ReceiptFromProduction/ReceiptFromProductionMaterialInput';
import ReceiptFromProductionMaterialUpload from '@/views/ReceiptFromProduction/ReceiptFromProductionMaterialUpload';
import ReceiptFromProductionCaseInput from '@/views/ReceiptFromProduction/ReceiptFromProductionCaseInput';
import ReceiptFromProductionCaseUpload from '@/views/ReceiptFromProduction/ReceiptFromProductionCaseUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		ReceiptFromProductionMaterialInput,ReceiptFromProductionMaterialUpload,
		ReceiptFromProductionCaseInput,ReceiptFromProductionCaseUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsReceiptFromProductionMaterial: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Source Material", key: 'controlCard', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: false}}, 
				{"qtyBefore": { "class" : "th-qty-before last-child", "label" : "Qty Before", key: 'qtyBefore', sortable: false}}, 
				{"qtyAfter": { "class" : "th-qty-after d-stack-none", "label" : "Qty After", key: 'qtyAfter', sortable: false}}, 
				{"qtyTaken": { "class" : "th-qty-taken d-stack-none", "label" : "Qty Taken", key: 'qtyTaken', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsReceiptFromProductionCase: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: false}}, 
				{"qtyMaterial": { "class" : "th-qty-material last-child", "label" : "Qty Material", key: 'qtyMaterial', sortable: false}}, 
				{"qtyCase": { "class" : "th-qty-case d-stack-none", "label" : "Qty Case", key: 'qtyCase', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelReceiptFromProductionMaterial : {},
			isShowPopupReceiptFromProductionMaterial : false,
			isShowPopupUploadReceiptFromProductionMaterial : false,
			modelReceiptFromProductionCase : {},
			isShowPopupReceiptFromProductionCase : false,
			isShowPopupUploadReceiptFromProductionCase : false,
			filterReceiptFromProduction : null,
			currentReceiptFromProductionPage : 1,
			receiptFromProductionPageSize: 10,
			sortByReceiptFromProduction: '',
			sortDescReceiptFromProduction: '',
			filterReceiptFromProductionMaterial : null,
			currentReceiptFromProductionMaterialPage : 1,
			receiptFromProductionMaterialPageSize: 10,
			sortByReceiptFromProductionMaterial: '',
			sortDescReceiptFromProductionMaterial: '',
			sortingByReceiptFromProductionMaterial: [],
			receiptFromProductionMaterials : [],
			receiptFromProductionMaterialId : '',
			totalReceiptFromProductionMaterialRow : 0,
			isShowReceiptFromProductionMaterialFilter: false,
			isDownloadReceiptFromProductionMaterial: false,
			filterReceiptFromProductionCase : null,
			currentReceiptFromProductionCasePage : 1,
			receiptFromProductionCasePageSize: 10,
			sortByReceiptFromProductionCase: '',
			sortDescReceiptFromProductionCase: '',
			sortingByReceiptFromProductionCase: [],
			receiptFromProductionCases : [],
			receiptFromProductionCaseId : '',
			totalReceiptFromProductionCaseRow : 0,
			isShowReceiptFromProductionCaseFilter: false,
			isDownloadReceiptFromProductionCase: false,
			controlCards: [],
			parts: [],
			workOrderProcessDetails: [],
			workOrderProcessDetails: [],
			isWorkOrderProcessDetailComboLoading: false,
			documentStatuss: [],
			documentStatuss: [],
			isDocumentStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isWorkOrderProcessDetailComboLoading: false,
			isDocumentStatusComboLoading: false,
			isReceiptFromProductionComboLoading: false,
			isControlCardComboLoading: false,
			isPartComboLoading: false,
		}
	},
	methods : {
		getReceiptFromProduction : async function(id) {
			this.isBusy = true;
			ReceiptFromProduction.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadReceiptFromProduction = true;
			this.filterReceiptFromProduction.id = this.modelId;
			ReceiptFromProduction.downloadDataDetail(this, this.filterReceiptFromProduction).then(result => {
				this.isDownloadReceiptFromProduction = false;
			}).catch(error => { this.isDownloadReceiptFromProduction = false; })
		},
		getReceiptFromProductionMaterials : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterReceiptFromProductionMaterial);
			if (this.modelId == null) return;
			filter.receiptFromProductionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByReceiptFromProductionMaterial != null) {
				this.sortingByReceiptFromProductionMaterial[this.sortByReceiptFromProductionMaterial] = this.sortDescReceiptFromProductionMaterial;
			}
			let currentPage = (this.currentReceiptFromProductionMaterialPage - 1);
			if (isAddRow) {
				let totalData = this.totalReceiptFromProductionMaterialRow + 1;
				let page = Math.ceil(totalData/this.receiptFromProductionMaterialPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.receiptFromProductionMaterialPageSize = 0;
			// disable paging end
			ReceiptFromProductionMaterial.getList(this, filter, this.sortingByReceiptFromProductionMaterial, currentPage , this.receiptFromProductionMaterialPageSize).then(result => {
				this.currentReceiptFromProductionMaterialPage = currentPage + 1;
				this.receiptFromProductionMaterials = result.data;
				this.totalReceiptFromProductionMaterialRow = result.dataCount;
			}).catch(error => {});
		},
		getReceiptFromProductionCases : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterReceiptFromProductionCase);
			if (this.modelId == null) return;
			filter.receiptFromProductionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByReceiptFromProductionCase != null) {
				this.sortingByReceiptFromProductionCase[this.sortByReceiptFromProductionCase] = this.sortDescReceiptFromProductionCase;
			}
			let currentPage = (this.currentReceiptFromProductionCasePage - 1);
			if (isAddRow) {
				let totalData = this.totalReceiptFromProductionCaseRow + 1;
				let page = Math.ceil(totalData/this.receiptFromProductionCasePageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.receiptFromProductionCasePageSize = 0;
			// disable paging end
			ReceiptFromProductionCase.getList(this, filter, this.sortingByReceiptFromProductionCase, currentPage , this.receiptFromProductionCasePageSize).then(result => {
				this.currentReceiptFromProductionCasePage = currentPage + 1;
				this.receiptFromProductionCases = result.data;
				this.totalReceiptFromProductionCaseRow = result.dataCount;
			}).catch(error => {});
		},
		getReceiptFromProductions : async function(input) {
			let filter = new ReceiptFromProductionFilter();
			if (input != undefined) {
				filter.WorkOrderProcessDetail = input;
			}
			this.isReceiptFromProductionComboLoading = true;
			ReceiptFromProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.receiptFromProductions = result.data
				}
				this.isReceiptFromProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getReceiptFromProductions : async function(input) {
			let filter = new ReceiptFromProductionFilter();
			if (input != undefined) {
				filter.workOrderProcessDetail = input;
			}
			this.isReceiptFromProductionComboLoading = true;
			ReceiptFromProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.receiptFromProductions = result.data
				}
				this.isReceiptFromProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessDetailId = null;
				this.model.workOrderProcessDetail = null;
			} else {
				this.model.workOrderProcessDetailId = item.id;
				this.model.workOrderProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.receiptFromProductionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					ReceiptFromProduction.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'receiptfromproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					ReceiptFromProduction.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'receiptfromproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ReceiptFromProduction.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getReceiptFromProduction(id);
					});
				}
			});
		},
		onHidden() {
			this.getReceiptFromProductions();
		},
		addRowDataReceiptFromProductionMaterial(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.receiptFromProductionId =  this.modelId;
					ReceiptFromProductionMaterial.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getReceiptFromProductionMaterials(true);
						this.isShowPopupReceiptFromProductionMaterial = false;
					})
				} else {
					model.receiptFromProductionId =  this.modelId;
					ReceiptFromProductionMaterial.createDataDetail(this, model)
					.then(result => {
						this.getReceiptFromProductionMaterials(true);
						this.isShowPopupReceiptFromProductionMaterial = false;
					})
				}
			}
		},
		async editRowDataReceiptFromProductionMaterial(id) {
			this.receiptFromProductionMaterialId = id;
			this.isShowPopupReceiptFromProductionMaterial = true; 
		},
		async deleteRowDataReceiptFromProductionMaterial(id) {
			ReceiptFromProductionMaterial.deleteData(this, id).then(result => { this.getReceiptFromProductionMaterials(); });
		},
		async resetDataReceiptFromProductionMaterial() {
			this.receiptFromProductionMaterialId = "";
			this.isShowPopupReceiptFromProductionMaterial = true;
		},
		async addDataReceiptFromProductionMaterial() {
			ReceiptFromProductionMaterial.createData(this, { receiptFromProductionId: this.modelId })
			.then(result => {
				this.getReceiptFromProductionMaterials(true);
			})
		},
		async addFromClipboardReceiptFromProductionMaterial() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, receiptFromProductionId: this.modelId });
				});
				ReceiptFromProductionMaterial.addFromClipboard(this, controlCards).then(result => { this.getReceiptFromProductionMaterials() });
			});
		},
		async replaceFromClipboardReceiptFromProductionMaterial() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, receiptFromProductionId: this.modelId });
				});
				ReceiptFromProductionMaterial.replaceFromClipboard(this, controlCards).then(result => { this.getReceiptFromProductionMaterials() });
			});   
		},
		showPopupUploadReceiptFromProductionMaterial() {
			if(this.receiptFromProductionMaterials != null && this.receiptFromProductionMaterials.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap ReceiptFromProductionMaterial akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadReceiptFromProductionMaterial = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadReceiptFromProductionMaterial = true;
			}
		},
		uploadDataReceiptFromProductionMaterial(modalEvent, newDatas) {
			this.isShowPopupUploadReceiptFromProductionMaterial = false; 
		},
		downloadReceiptFromProductionMaterial(modalEvent) {
			this.isDownloadReceiptFromProductionMaterial = true;
			this.filterReceiptFromProductionMaterial.receiptFromProductionId = this.modelId;
			ReceiptFromProductionMaterial.downloadDataDetail(this, this.filterReceiptFromProductionMaterial).then(result => {
				this.isDownloadReceiptFromProductionMaterial = false;
			}).catch(error => { this.isDownloadReceiptFromProductionMaterial = false; })
		},
		saveInputReceiptFromProductionMaterial(item) {
			if (this.receiptFromProductions != null && this.receiptFromProductions != undefined  && this.receiptFromProductions.length > 0) {
				item.receiptFromProduction = this.receiptFromProductions.find(q => q.id == item.receiptFromProductionId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ReceiptFromProductionMaterial.updateDataDetail(this, item, item.id);
				}
			});
		},
		addRowDataReceiptFromProductionCase(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.receiptFromProductionId =  this.modelId;
					ReceiptFromProductionCase.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getReceiptFromProductionCases(true);
						this.isShowPopupReceiptFromProductionCase = false;
					})
				} else {
					model.receiptFromProductionId =  this.modelId;
					ReceiptFromProductionCase.createDataDetail(this, model)
					.then(result => {
						this.getReceiptFromProductionCases(true);
						this.isShowPopupReceiptFromProductionCase = false;
					})
				}
			}
		},
		async editRowDataReceiptFromProductionCase(id) {
			this.receiptFromProductionCaseId = id;
			this.isShowPopupReceiptFromProductionCase = true; 
		},
		async deleteRowDataReceiptFromProductionCase(id) {
			ReceiptFromProductionCase.deleteData(this, id).then(result => { this.getReceiptFromProductionCases(); });
		},
		async resetDataReceiptFromProductionCase() {
			this.receiptFromProductionCaseId = "";
			this.isShowPopupReceiptFromProductionCase = true;
		},
		async addDataReceiptFromProductionCase() {
			ReceiptFromProductionCase.createData(this, { receiptFromProductionId: this.modelId })
			.then(result => {
				this.getReceiptFromProductionCases(true);
			})
		},
		async addFromClipboardReceiptFromProductionCase() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, receiptFromProductionId: this.modelId });
				});
				ReceiptFromProductionCase.addFromClipboard(this, controlCards).then(result => { this.getReceiptFromProductionCases() });
			});
		},
		async replaceFromClipboardReceiptFromProductionCase() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, receiptFromProductionId: this.modelId });
				});
				ReceiptFromProductionCase.replaceFromClipboard(this, controlCards).then(result => { this.getReceiptFromProductionCases() });
			});   
		},
		showPopupUploadReceiptFromProductionCase() {
			if(this.receiptFromProductionCases != null && this.receiptFromProductionCases.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap ReceiptFromProductionCase akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadReceiptFromProductionCase = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadReceiptFromProductionCase = true;
			}
		},
		uploadDataReceiptFromProductionCase(modalEvent, newDatas) {
			this.isShowPopupUploadReceiptFromProductionCase = false; 
		},
		downloadReceiptFromProductionCase(modalEvent) {
			this.isDownloadReceiptFromProductionCase = true;
			this.filterReceiptFromProductionCase.receiptFromProductionId = this.modelId;
			ReceiptFromProductionCase.downloadDataDetail(this, this.filterReceiptFromProductionCase).then(result => {
				this.isDownloadReceiptFromProductionCase = false;
			}).catch(error => { this.isDownloadReceiptFromProductionCase = false; })
		},
		saveInputReceiptFromProductionCase(item) {

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ReceiptFromProductionCase.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadReceiptFromProductionMaterial = false; 
			this.isShowPopupReceiptFromProductionMaterial = false; 
			if (modalType == 'ReceiptFromProductionMaterial') {
				this.getReceiptFromProductionMaterials();
			}
			this.isShowPopupUploadReceiptFromProductionCase = false; 
			this.isShowPopupReceiptFromProductionCase = false; 
			if (modalType == 'ReceiptFromProductionCase') {
				this.getReceiptFromProductionCases();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowReceiptFromProductionMaterialFilter = true;
				//this.isShowReceiptFromProductionCaseFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterReceiptFromProduction = new ReceiptFromProductionFilter();
		this.filterReceiptFromProductionMaterial = new ReceiptFromProductionMaterialFilter();
		this.filterReceiptFromProductionCase = new ReceiptFromProductionCaseFilter();
		//this.getReceiptFromProductions();
		//this.getControlCards();
		//this.getParts();
		//this.getWorkOrderProcessDetails();
		//this.getDocumentStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getReceiptFromProduction(id);
			} else {
				this.modelId = id;
				this.getReceiptFromProduction(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByReceiptFromProductionMaterial : {
			handler: function() {
				this.getReceiptFromProductionMaterials();
			}
		},
		sortDescReceiptFromProductionMaterial: {
			handler: function() {
				this.getReceiptFromProductionMaterials();
			}
		},
		currentReceiptFromProductionMaterialPage: {
			handler: function() {
				this.getReceiptFromProductionMaterials();
			}
		},
		receiptFromProductionMaterialPageSize : {
			handler: function() {
				this.getReceiptFromProductionMaterials();
			}
		},
		filterReceiptFromProductionMaterial: {
			handler: function() {
				this.getReceiptFromProductionMaterials();
			},
			deep: true,
		},
		sortByReceiptFromProductionCase : {
			handler: function() {
				this.getReceiptFromProductionCases();
			}
		},
		sortDescReceiptFromProductionCase: {
			handler: function() {
				this.getReceiptFromProductionCases();
			}
		},
		currentReceiptFromProductionCasePage: {
			handler: function() {
				this.getReceiptFromProductionCases();
			}
		},
		receiptFromProductionCasePageSize : {
			handler: function() {
				this.getReceiptFromProductionCases();
			}
		},
		filterReceiptFromProductionCase: {
			handler: function() {
				this.getReceiptFromProductionCases();
			},
			deep: true,
		},
	},
}
</script>
